// src/constants/mapConfig.js

/**
 * 全国MAPビュー専用設定
 *
 * 【運用ルール】
 * - スポット追加時: SPOT_CONFIG にエントリを追加する
 * - ラリー追加時: RALLY_META にエントリを追加する
 * - エリアカラー変更時: AREA_META の color を更新してデプロイ（1箇所のみ）
 * - 表示エリア変更時: .env の REACT_APP_ACTIVE_AREAS を更新してビルド
 */

// ── エリア定義 ─────────────────────────────────────────────────────

export const AREA_META = {
  east: {
    displayName: '東日本',
    color: '#920000',
    centerLat: 37.5,
    centerLng: 140.5,
  },
  central: {
    displayName: '中部',
    color: '#3182CE',
    centerLat: 35.0,
    centerLng: 137.5,
  },
  west: {
    displayName: '西日本',
    color: '#D69E2E',
    centerLat: 34.5,
    centerLng: 133.5,
  },
};

export const ACTIVE_AREAS =
  (process.env.REACT_APP_ACTIVE_AREAS || 'east,west').split(',');

// ── スポット設定（中心となるデータ構造）────────────────────────────

/**
 * スポット設定（Map専用）
 *
 * - rallyIds: 所属するラリーIDの配列。複数可。GoalBannerのタブ表示順に対応
 * - mapGoalCount: 目標スタンプ数。ラリーをまたいで共通
 * - area: スポットのエリアID。ピン色・ACTIVE_AREAS フィルターに使用
 * - hideFromMap: true のスポットはマップに表示しないが、達成進捗には加算される（UMAスポット等）
 * - stampCampaign: スタンプ倍数キャンペーン設定。未設定の場合はキャンペーンなし
 *     { multiplier: number, startDate: string (YYYY-MM-DD), endDate: string (YYYY-MM-DD) }
 */
export const SPOT_CONFIG = {
  // ── all ラリー（東日本） ───────────────────────────────────────
  all_21: { rallyIds: ['all_east'], mapGoalCount: 10,  area: 'east',  isGlobal: true },
  all_22: { rallyIds: ['all_east'], mapGoalCount: 30,  area: 'east',  isGlobal: true },
  all_23: { rallyIds: ['all_east'], mapGoalCount: 30,  area: 'east',  isGlobal: true  },
  all_24: { rallyIds: ['all_east'], mapGoalCount: 30,  area: 'east',  isGlobal: true  },
  all_25: { rallyIds: ['all_east'], mapGoalCount: 50,  area: 'east',  isGlobal: true  },
  all_26: { rallyIds: ['all_east'], mapGoalCount: 100, area: 'east',  isGlobal: true  },
  all_27: { rallyIds: ['all_east'], mapGoalCount: 100, area: 'east',  isGlobal: true  },
  all_28: { rallyIds: ['all_east'], mapGoalCount: 100, area: 'east',  isGlobal: true  },
  all_29: { rallyIds: ['all_east', 'chibazoo'], mapGoalCount: 100, area: 'east',  isGlobal: true  },
  all_30: { rallyIds: ['all_east'], mapGoalCount: 100, area: 'east',  isGlobal: true  },
  all_31: { rallyIds: ['all_east'], mapGoalCount: 50,  area: 'east',  isGlobal: true,
    stampCampaign: { multiplier: 2, startDate: '2026-07-31', endDate: '2026-09-30' },
  },
  all_32: { rallyIds: ['all_east'], mapGoalCount: 50,  area: 'east',  isGlobal: true,
    stampCampaign: { multiplier: 2, startDate: '2026-07-31', endDate: '2026-09-30' },
  },
  all_33: { rallyIds: ['all_east'], mapGoalCount: 100, area: 'east',  isGlobal: true  },
  all_34: { rallyIds: ['all_east'], mapGoalCount: 100, area: 'east',  isGlobal: true  },
  all_35: { rallyIds: ['all_east'], mapGoalCount: 100, area: 'east',  isGlobal: true  },

  // ── all ラリー西日本（西日本） ─────────────────────────────────
  all_36: { rallyIds: ['all_west'], mapGoalCount: 30, area: 'west', isGlobal: true },
  all_37: { rallyIds: ['all_west'], mapGoalCount: 80, area: 'west', isGlobal: true },
  all_38: { rallyIds: ['all_west'], mapGoalCount: 80, area: 'west', isGlobal: true },
  all_39: { rallyIds: ['all_west'], mapGoalCount: 80, area: 'west', isGlobal: true },
  all_40: { rallyIds: ['all_west'], mapGoalCount: 80, area: 'west', isGlobal: true },
  all_41: { rallyIds: ['all_west'], mapGoalCount: 80, area: 'west', isGlobal: true },
  all_42: { rallyIds: ['all_west'], mapGoalCount: 80, area: 'west', isGlobal: true },
  all_43: { rallyIds: ['all_west'], mapGoalCount: 80, area: 'west', isGlobal: true },
  all_44: { rallyIds: ['all_west'], mapGoalCount: 80, area: 'west', isGlobal: true },
  all_45: { rallyIds: ['all_west'], mapGoalCount: 30, area: 'west', isGlobal: true },
  all_46: { rallyIds: ['all_west'], mapGoalCount: 30, area: 'west', isGlobal: true },
  all_47: { rallyIds: ['all_west'], mapGoalCount: 30, area: 'west', isGlobal: true },
  all_48: { rallyIds: ['all_west'], mapGoalCount: 30, area: 'west', isGlobal: true },
  all_49: { rallyIds: ['all_west'], mapGoalCount: 30, area: 'west', isGlobal: true },
  all_50: { rallyIds: ['all_west'], mapGoalCount: 30, area: 'west', isGlobal: true },
  all_51: { rallyIds: ['all_west'], mapGoalCount: 10, area: 'west', isGlobal: true },
  all_52: { rallyIds: ['all_west'], mapGoalCount: 10, area: 'west', isGlobal: true },

  // ── ueno ラリー（東日本） ─────────────────────────────────────
  ueno_1: { rallyIds: ['ueno'],        mapGoalCount: 250, area: 'east' },
  ueno_2: { rallyIds: ['all_east', 'ueno'], mapGoalCount: 100, area: 'east',  isGlobal: true  },
  ueno_3: { rallyIds: ['ueno'],        mapGoalCount: 250, area: 'east' },
  ueno_4: { rallyIds: ['ueno'],        mapGoalCount: 250, area: 'east' },
  ueno_5: { rallyIds: ['ueno'],        mapGoalCount: 250, area: 'east' },
  ueno_6: { rallyIds: ['ueno'],        mapGoalCount: 250, area: 'east' },

  // ── kasairinkai ラリー（東日本） ──────────────────────────────
  kasairinkai_14: { rallyIds: ['kasairinkai'],        mapGoalCount: 100, area: 'east' },
  kasairinkai_15: { rallyIds: ['kasairinkai'],        mapGoalCount: 100, area: 'east' },
  kasairinkai_16: { rallyIds: ['kasairinkai'],        mapGoalCount: 100, area: 'east' },
  kasairinkai_17: { rallyIds: ['all_east', 'kasairinkai'], mapGoalCount: 100, area: 'east',  isGlobal: true  },
  kasairinkai_18: { rallyIds: ['kasairinkai'],        mapGoalCount: 100, area: 'east' },
  kasairinkai_19: { rallyIds: ['kasairinkai'],        mapGoalCount: 100, area: 'east' },
  kasairinkai_20: { rallyIds: ['null'],        mapGoalCount: 100, area: 'east' },

  // ── katsurahama ラリー（西日本） ──────────────────────────────
  katsurahama_7:  { rallyIds: ['all_west', 'katsurahama'], mapGoalCount: 40, area: 'west', isGlobal: true  },
  katsurahama_8:  { rallyIds: ['katsurahama'], mapGoalCount: 250, area: 'west' },
  katsurahama_9:  { rallyIds: ['katsurahama'], mapGoalCount: 250, area: 'west' },
  katsurahama_10: { rallyIds: ['katsurahama'], mapGoalCount: 250, area: 'west' },
  katsurahama_11: { rallyIds: ['katsurahama'], mapGoalCount: 250, area: 'west' },
  katsurahama_12: { rallyIds: ['katsurahama'], mapGoalCount: 250, area: 'west' },
  katsurahama_13: { rallyIds: ['katsurahama'], mapGoalCount: 250, area: 'west' },

  // ── chibazoo ラリー（東日本） ──────────────────────────────
  chibazoo_53:  { rallyIds: ['chibazoo'], mapGoalCount: 100, area: 'east'  },
  chibazoo_54:  { rallyIds: ['chibazoo'], mapGoalCount: 100, area: 'east'  },
  chibazoo_55:  { rallyIds: ['chibazoo'], mapGoalCount: 100, area: 'east'  },
  chibazoo_56:  { rallyIds: ['chibazoo'], mapGoalCount: 100, area: 'east'  },
  chibazoo_57:  { rallyIds: ['chibazoo'], mapGoalCount: 100, area: 'east'  },
  chibazoo_58:  { rallyIds: ['chibazoo'], mapGoalCount: 100, area: 'east'  },
  chibazoo_59:  { rallyIds: ['chibazoo'], mapGoalCount: 100, area: 'east'  },
  chibazoo_60:  { rallyIds: ['chibazoo'], mapGoalCount: 100, area: 'east'  },
  chibazoo_61:  { rallyIds: ['chibazoo'], mapGoalCount: 100, area: 'east', hideFromMap: true },

  // ── all ラリー（中部） ─────────────────────────────────────────
  // ⚠️ 中部エリアを表示するには REACT_APP_ACTIVE_AREAS に 'central' を追加すること
  all_62: { rallyIds: ['all_central'], mapGoalCount: 10,  area: 'central', isGlobal: true }, // 富山市ファミリーパーク
  all_63: { rallyIds: ['all_central'], mapGoalCount: 10,  area: 'central', isGlobal: true }, // いしかわ動物園
  all_64: { rallyIds: ['all_central'], mapGoalCount: 10,  area: 'central', isGlobal: true }, // のとじま臨海公園水族館
  all_65: { rallyIds: ['all_central'], mapGoalCount: 10,  area: 'central', isGlobal: true }, // 鯖江市西山動物園
  all_66: { rallyIds: ['all_central'], mapGoalCount: 10,  area: 'central', isGlobal: true }, // 飯田市立動物園
  all_67: { rallyIds: ['all_central'], mapGoalCount: 10,  area: 'central', isGlobal: true }, // 長野市茶臼山動物園
  all_68: { rallyIds: ['all_central'], mapGoalCount: 30,  area: 'central', isGlobal: true }, // 富士サファリパーク
  all_69: { rallyIds: ['all_central'], mapGoalCount: 30,  area: 'central', isGlobal: true }, // 伊豆アニマルキングダム
  all_70: { rallyIds: ['all_central'], mapGoalCount: 30,  area: 'central', isGlobal: true }, // 熱川バナナワニ園
  all_71: { rallyIds: ['all_central'], mapGoalCount: 30,  area: 'central', isGlobal: true }, // 伊豆シャボテン動物公園
  all_72: { rallyIds: ['all_central'], mapGoalCount: 80,  area: 'central', isGlobal: true }, // 静岡市立日本平動物園
  all_73: { rallyIds: ['all_central'], mapGoalCount: 80,  area: 'central', isGlobal: true }, // 浜松市動物園
  all_74: { rallyIds: ['all_central'], mapGoalCount: 80,  area: 'central', isGlobal: true }, // 名古屋市東山動植物園
  all_76: { rallyIds: ['all_central'], mapGoalCount: 80,  area: 'central', isGlobal: true }, // 岡崎市東公園動物園
  all_77: { rallyIds: ['all_central'], mapGoalCount: 80,  area: 'central', isGlobal: true }, // 名古屋港水族館

  // ── nonhoi ラリー（中部） ────────────────────────────────────
  // ⚠️ nonhoiラリー正式リリースまでは rallyIds に 'nonhoi' を含めない（SpotDetailSheetのラリータブに表示されてしまうため）
  nonhoi_75: { rallyIds: ['all_central', 'nonhoi'], mapGoalCount: 80, area: 'central', isGlobal: true }, // のんほいパーク(豊橋総合動植物公園)
  nonhoi_78: { rallyIds: ['nonhoi'], mapGoalCount: 80, area: 'central' }, // のんほいパーク(園内①) マンドリルエリア
  nonhoi_79: { rallyIds: ['nonhoi'], mapGoalCount: 80, area: 'central' }, // のんほいパーク(園内②) 新ゾウ舎(建設中)
  nonhoi_80: { rallyIds: ['nonhoi'], mapGoalCount: 80, area: 'central' }, // のんほいパーク(園内③) 夜行性動物館
  nonhoi_81: { rallyIds: ['nonhoi'], mapGoalCount: 80, area: 'central' }, // JR 二川駅
  nonhoi_82: { rallyIds: ['nonhoi'], mapGoalCount: 80, area: 'central' }, // 豊橋観光案内所
  nonhoi_83: { rallyIds: ['nonhoi'], mapGoalCount: 80, area: 'central' }, // JR 豊橋駅
  nonhoi_84: { rallyIds: ['nonhoi'], mapGoalCount: 80, area: 'central' }, // 吉田城
  nonhoi_85: { rallyIds: ['nonhoi'], mapGoalCount: 80, area: 'central' }, // 手筒花火体験パーク(豊橋市役所東館13階)
  nonhoi_86: { rallyIds: ['nonhoi'], mapGoalCount: 80, area: 'central', hideFromMap: true }, // 園内売店
};

// ── ラリーメタ情報 ─────────────────────────────────────────────────

export const RALLY_META = {
  all_east:    { displayName: '日本全国 動物園・水族館スポットラリー 東日本',        area: 'east',    isGlobal: true },
  all_central: { displayName: '日本全国 動物園・水族館スポットラリー 中部',          area: 'central', isGlobal: true },
  all_west:    { displayName: '日本全国 動物園・水族館スポットラリー 西日本',        area: 'west',    isGlobal: true },
  ueno:        { displayName: '上野動物園周辺スポットラリー',                      area: 'east' },
  kasairinkai: { displayName: '葛西臨海水族園周辺スポットラリー',                   area: 'east' },
  katsurahama: { displayName: '桂浜水族館周辺スポットラリー',                      area: 'west' },
  chibazoo:    { displayName: '千葉市動物公園周辺スポットラリー',                   area: 'east' },
  nonhoi:      { displayName: 'のんほいパーク周辺スポットラリー',                   area: 'central' },
};

// ── Map用達成条件 ──────────────────────────────────────────────────

export const MAP_GOAL_CONFIG = {
  // national: {
  //   everyoneGoal: null,
  // },
  // areas: {
  //   east: {
  //     everyoneGoal: {
  //       reward: {
  //         text: 'スペシャルバスツアーを開催！',
  //         description: 'みんなの力で、東日本エリア17スポット毎の目標スタンプ数を\nクリアしてスペシャルバスツアーを実現しよう！',
  //       },
  //       targetSpotIds: [
  //         'ueno_2',
  //         'kasairinkai_17',
  //         'all_21', 'all_22', 'all_23', 'all_24', 'all_25',
  //         'all_26', 'all_27', 'all_28', 'all_29', 'all_30',
  //         'all_31', 'all_32', 'all_33', 'all_34', 'all_35',
  //       ],
  //     },
  //   },
  //   central: { everyoneGoal: null },
  //   west:    { everyoneGoal: null },
  // },
  rallies: {
    /**
     * 各ラリーの達成条件
     * - reward.description: 達成報酬テキスト（null = 「近日公開予定」と表示）
     * - targetSpotIds: 未設定の場合は getSpotIdsByRallyId() で自動導出
     */
    all_east: {
      everyoneGoal: {
        reward: {
          text: 'スペシャルバスツアーを開催！',
          description: 'みんなの力で、東日本エリア17スポット毎の目標スタンプ数を\nクリアしてスペシャルバスツアーを実現しよう！',
        },
      },
    },
    all_west: {
      everyoneGoal: {
        reward: {
          text: 'スペシャルバスツアーを開催！',
          description: 'みんなの力で、西日本エリア18スポット毎の目標スタンプ数を\nクリアしてスペシャルバスツアーを実現しよう！',
        },
      },
    },
    ueno: {
      everyoneGoal: {
        reward: {
          text: 'スタンプラリースポットのある場所にスタンディパネルが登場！',
          description: 'みんなの力で、上野動物園周辺スポットラリー全6スポットで目標スタンプ数をクリアすると、ジオラマアクリルスタンドが販売開始！',
        },
      },
    },
    kasairinkai: {
      everyoneGoal: {
        reward: {
          text: 'スタンプラリースポットのある場所にスタンディパネルが登場！',
          description: 'みんなの力で、葛西臨海水族園周辺スポットラリー全6スポットで目標スタンプ数をクリアすると、ジオラマアクリルスタンドが販売開始！',
        },
      },
    },
    katsurahama: {
      everyoneGoal: {
        reward: {
          text: 'スタンプラリースポットのある場所にスタンディパネルが登場！',
          description: 'みんなの力で、桂浜水族館園周辺スポットラリー全7スポットで目標スタンプ数をクリアすると、ジオラマアクリルスタンドが販売開始！',
        },
      },
    },
    chibazoo: {
      everyoneGoal: {
        reward: {
          text: 'スタンプラリースポットのある場所にスタンディパネルが登場！',
          description: 'みんなの力で、千葉市動物公園周辺スポットラリー全10スポットで目標スタンプ数をクリアすると、ジオラマアクリルスタンドが販売開始！',
        },
      },
    },
    all_central: {
      everyoneGoal: {
        reward: {
          text: 'スペシャルバスツアーを開催！',
          description: 'みんなの力で、中部エリア16スポット毎の目標スタンプ数を\nクリアしてスペシャルバスツアーを実現しよう！',
        },
      },
    },
    nonhoi: {
      everyoneGoal: {
        reward: {
          text: 'スタンプラリースポットのある場所にスタンディパネルが登場！',
          description: 'みんなの力で、のんほいパーク周辺スポットラリー全10スポットで目標スタンプ数をクリアすると、ジオラマアクリルスタンドが販売開始！',
        },
      },
    },
  },
};

// ── ヘルパー関数 ───────────────────────────────────────────────────

/**
 * スポットの mapGoalCount を取得
 * （第2引数 rallyId は後方互換のため無視）
 */
export const getMapGoalCount = (spotId) => {
  return SPOT_CONFIG[spotId]?.mapGoalCount ?? 0;
};

/**
 * スポットが属するラリーIDの配列を返す
 * @returns {string[]} 例: ['all', 'ueno']
 */
export const getRallyIdsBySpotId = (spotId) => {
  return SPOT_CONFIG[spotId]?.rallyIds ?? [];
};

/**
 * ラリーに属するスポットIDの配列を返す（SPOT_CONFIG を逆引き）
 * @returns {string[]} 例: ['ueno_1', 'ueno_2', ...]
 */
export const getSpotIdsByRallyId = (rallyId) => {
  return Object.entries(SPOT_CONFIG)
    .filter(([, cfg]) => cfg.rallyIds.includes(rallyId))
    .map(([spotId]) => spotId);
};

/**
 * スポットのエリアIDを返す
 * @returns {string|null} 例: 'west'
 */
export const getAreaBySpotId = (spotId) => {
  return SPOT_CONFIG[spotId]?.area ?? null;
};

/**
 * スポットが全国版ラリーに属するかどうかを返す
 * isGlobal: true のスポット = 「の」アイコン管理の全国ラリー
 * isGlobal: false/未設定   = ひろば管理の単独ラリー
 * @returns {boolean}
 */
export const getIsGlobalBySpotId = (spotId) => {
  return SPOT_CONFIG[spotId]?.isGlobal === true;
};

/**
 * エリア達成判定
 */
export const isAreaAchieved = (areaId, spotsData = []) => {
  const areaGoal = MAP_GOAL_CONFIG.areas[areaId]?.everyoneGoal;
  if (!areaGoal?.targetSpotIds?.length) return false;

  return areaGoal.targetSpotIds.every((spotId) => {
    const goalCount = getMapGoalCount(spotId);
    const spot = spotsData.find((s) => s.id === spotId);
    return spot && (spot.stampCount ?? 0) >= goalCount;
  });
};

/**
 * ラリー達成判定（Map用）
 */
export const isRallyAchievedMap = (rallyId, spotsData = []) => {
  const spotIds = getSpotIdsByRallyId(rallyId);
  if (spotIds.length === 0) return false;

  return spotIds.every((spotId) => {
    const goalCount = getMapGoalCount(spotId);
    const spot = spotsData.find((s) => s.id === spotId);
    return spot && (spot.stampCount ?? 0) >= goalCount;
  });
};

/**
 * スポットのスタンプキャンペーン設定を返す
 * キャンペーン期間外・未設定の場合は null を返す
 * @returns {{ multiplier: number, startDate: string, endDate: string } | null}
 */
export const getStampCampaign = (spotId) => {
  const campaign = SPOT_CONFIG[spotId]?.stampCampaign;
  if (!campaign) return null;
  const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  if (today < campaign.startDate || today > campaign.endDate) return null;
  return campaign;
};

// 足跡ピンを表示するズームレベルの下限（画面調整しながら変更する）
export const FOOTPRINT_ZOOM_THRESHOLD = 9;

